import {Component, Input} from '@angular/core'
import { Router } from '@angular/router'
import { Location } from '@angular/common'
import { NuclearObservable } from '../../../nuclear-observable'
import { BaseComponent } from '../../../components/base.component'
import { Customer, Account, Route } from '../../../types'
import { customerGetters } from '../../../stores/customer-store'
import { isAgencySignup, possessive } from '../../../utils'
import {
  industryComplete,
  toneComplete,
  onlinePresenceComplete,
  audienceAndVoiceComplete,
  otherInfoComplete
} from '../../../logic/customer-signup'

@Component({
  selector: 'about-nav-v1',
  template: `
    <div class="subsections huge-top-buffer no-medium-or-smaller">
      <div class="subsection" [class.active]="isActive(['NcIndustry'])">
        <span id="industry-link" class="cursor-pointer" [routerLink]="['../', 'industry']">
          <span class="title">
            <span *ngIf="!isAgencySignup()">Your </span><span>Industry</span>
          </span>
          <span *ngIf="industryComplete()" class="fas fa-check small-left-buffer"></span>
        </span>
      </div>
      <div class="subsection" [class.active]="isActive(['NcTone'])">
        <span id="tone-link" class="cursor-pointer" [routerLink]="['../', 'tone']">
          <span class="title">
            <span *ngIf="!isAgencySignup()">Your </span><span>Tone</span>
          </span>
          <span *ngIf="toneComplete()" class="fas fa-check small-left-buffer"></span>
        </span>
      </div>
      <div class="subsection" [class.active]="isActive(['NcOnlinePresence'])">
        <span id="online-presence-link" class="cursor-pointer" [routerLink]="['../', 'online_presence']">
          <span class="title">
            <span *ngIf="!isAgencySignup()">Your </span><span>Online Presence</span>
          </span>
          <span *ngIf="onlinePresenceComplete()" class="fas fa-check small-left-buffer"></span>
        </span>
      </div>
      <div class="subsection" [class.active]="isActive(['NcAudienceAndVoice'])">
        <span id="audience-and-voice-link" class="cursor-pointer" [routerLink]="['../', 'audience']">
          <span class="title">
            <span *ngIf="!isAgencySignup()">Your </span><span>Audience and Voice</span>
          </span>
          <span *ngIf="audienceAndVoiceComplete()" class="fas fa-check small-left-buffer"></span>
        </span>
      </div>
      <div class="subsection" [class.active]="isActive(['NcOtherInfo'])">
        <span id="other-info-link" class="cursor-pointer" [routerLink]="['../', 'other_info']">
          <span class="title">Additional Info for Writers</span>
        </span>
        <span *ngIf="otherInfoComplete()" class="fas fa-check small-left-buffer"></span>
      </div>
    </div>
  `
})
export class AboutNavV1 extends BaseComponent {
  @Input() customer: Customer;
  private account: Account;

  constructor(private router: Router,
              private location: Location) {
    super()
    const accountObs = NuclearObservable.from<Account>(customerGetters.account, { toJS: true }).subscribe(a => this.account = a)
    this.observers.push(accountObs)
  }

  isActive(route: Route): boolean {
    // return this.Router.isRouteActive(location);
    let path = this.location.path()
    let routeName = route ? route[0] : ''
    if (path) {
      if (routeName === 'NcIndustry' && (path.match(/.+?\/\d+\/about\/industry(\?|$)/) || path.match(/\/signup\/\d+\/about(\?|$)/))) {
        return true
      }
      else if (routeName === 'NcTone' && path.match(/.+?\/\d+\/about\/tone(\?|$)/)) {
        return true
      }
      else if (routeName === 'NcOnlinePresence' && path.match(/.+?\/\d+\/about\/online_presence(\?|$)/)) {
        return true
      }
      else if (routeName === 'NcAudienceAndVoice' && path.match(/.+?\/\d+\/about\/audience(\?|$)/)) {
        return true
      }
      else if (routeName === 'NcOtherInfo' && path.match(/.+?\/\d+\/about\/other_info(\?|$)/)) {
        return true
      }
    }
  }

  isAgencySignup(): boolean {
    return isAgencySignup(this.account)
  }

  possessive(str: string): string {
    if (str) {
      return possessive(str)
    } else {
      return 'Your client\'s'
    }
  }

  industryComplete(): boolean {
    return industryComplete(this.customer)
  }

  toneComplete(): boolean {
    return toneComplete(this.customer)
  }

  onlinePresenceComplete(): boolean {
    return onlinePresenceComplete(this.customer)
  }

  audienceAndVoiceComplete(): boolean {
    return audienceAndVoiceComplete(this.customer)
  }

  otherInfoComplete(): boolean {
    return otherInfoComplete(this.customer)
  }

}
